import styled from 'styled-components';

const PageContainer = styled.div`
  min-width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 60px;
`;

export default PageContainer;
